export default "__VITE_ASSET__C$n0D8e8__"